<template>
  <div id="mobile-navigation-wrapper">
    <navigation-icon
      :icon="mobileMenuOpen ? 'x' : 'menu'"
      id="navigation-menu-toggle"
      @click="toggleMobileMenu"
    />
    <div id="mobile-navigation-menu" v-if="mobileMenuOpen">
      <div id="mobile-navigation-modal">
        <div
          class="navigation-item"
          v-for="(icon, index) in icons"
          :key="index"
        >
          <navigation-icon
            :icon="icon.svg"
            @click="navigate(icon.navigation)"
          />
          <div
            class="active-indicator"
            v-if="icon.navigation === activeRoute"
          ></div>
        </div>
      </div>
      <backdrop
        id="mobile-navigation-backdrop"
        @click="toggleMobileMenu"
      ></backdrop>
    </div>
  </div>
  <div id="desktop-navigation-wrapper">
    <div class="navigation-item" v-for="(icon, index) in icons" :key="index">
      <navigation-icon :icon="icon.svg" @click="navigate(icon.navigation)" />
      <div
        class="active-indicator"
        v-if="icon.navigation === activeRoute"
      ></div>
    </div>
  </div>
  <profile-editor
    :contact="this.$store.getters.user"
    v-if="profileEditorOpen"
    @close="closePopup"
  />
</template>
<script>
import Backdrop from "../UI/Backdrop.vue";
import NavigationIcon from "./NavigationIcon.vue";
import ProfileEditor from "../ProfileEditor.vue";
export default {
  data() {
    return {
      profileEditorOpen: false,
      mobileMenuOpen: false,
    };
  },
  computed: {
    tenant() {
      if (this.$store.state.user) {
        return (
          this.$store.state.user.userId === this.$store.state.user.tenantId
        );
      } else {
        return false;
      }
    },
    icons() {
      let icons = [
        {
          svg: "person",
          navigation: "profile-editor",
        },
        {
          svg: "house",
          navigation: "dashboard",
        },
      ];

      if (this.tenant) {
        icons.push(
          {
            svg: "group-people",
            navigation: "contacts",
          },
          {
            svg: "calendar",
            navigation: "calendar",
          },
          {
            svg: "music-note",
            navigation: "library",
          },
          {
            svg: "settings",
            navigation: "config",
          },
          // {
          //   svg: "automation",
          //   navigation: "",
          // },
          {
            svg: "plus",
            navigation: "create-event",
          }
        );
      }
      icons.push({
        svg: "sign-out",
        navigation: "sign-out",
      });

      return icons;
    },
    activeRoute() {
      return this.$route.name;
    },
  },
  methods: {
    navigate(navigation) {
      switch (navigation) {
        case "profile-editor":
          this.profileEditorOpen = true;
          if (this.mobileMenuOpen) {
            this.mobileMenuOpen = false;
          }
          break;
        case "sign-out":
          this.$store.dispatch("logout");
          break;
        default:
          this.$router.push("/" + navigation);
          break;
      }
    },
    closePopup() {
      this.profileEditorOpen = false;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
  },
  components: { NavigationIcon, ProfileEditor, Backdrop },
  props: [],
  emits: ["logout"],
};
</script>
<style scoped>
@media screen {
  @media (max-width: 800px) {
    #desktop-navigation-wrapper {
      display: none;
    }
    #mobile-navigation-wrapper {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      max-height: 100%;
      padding: 20px;
      box-sizing: border-box;
      z-index: 2;
    }

    #navigation-menu-toggle {
      position: absolute;
      left: calc(50% - 20px);
      top: 40px;
      z-index: 11;
      filter: drop-shadow(0px 0px 5px var(--shadow));
    }

    #mobile-navigation-menu {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 10;
    }

    #mobile-navigation-backdrop {
      z-index: 1;
    }

    #mobile-navigation-modal {
      position: absolute;
      height: fit-content;
      width: calc(100% - 30px);
      z-index: 10;
      top: 0;
      left: 0;
      padding-top: 75px;
      margin: 15px;
      box-sizing: border-box;

      display: grid;
      grid-template-columns: repeat(3, 1fr);
      justify-items: space-evenly;

      border-radius: 8px;
      background-color: var(--backgroundColor);
      filter: drop-shadow(0px 0px 5px var(--shadow));
    }

    .navigation-item {
      height: 100px;
      /* height: fit-content; */
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      filter: drop-shadow(0px 0px 5px var(--shadow));
    }
    .active-indicator {
      height: 6px;
      width: 40px;
      margin-top: 12px;
      border-radius: 2px;
      background-color: var(--accentColor);
    }
  }
  @media (min-width: 800px) {
    #mobile-navigation-wrapper {
      display: none;
    }
    #desktop-navigation-wrapper {
      height: 80vh;
      max-height: 80vh;
      box-sizing: border-box;
      width: 70px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .navigation-item {
      height: fit-content;
      display: flex;
      flex-direction: row;
    }
    .active-indicator {
      width: 6px;
      height: 40px;
      margin-left: 12px;
      border-radius: 2px;
      background-color: var(--accentColor);
    }
  }
}

@media print {
  #desktop-navigation-wrapper,
  #mobile-navigation-wrapper {
    display: none;
  }
}
</style>
